import { nodeDefinitions } from "../configs/default-items-definition";
import { nodeItemsConfig } from "../configs/default-items-config";
import { nodeItemsConfig as enrollmentItemsConfig } from "../configs/default-enrollment-items-config";
import { augmentEnrollmentDefinitions } from "../configs/default-enrollment-items-definition";
import { useEffect, useState } from "react";

const useScenarioConfig = (tasks, itemType = 'scenario', itemsConfigOverride) => {
  const [normalizeNodesDefinitions, setNormalizeNodeDefinitions] = useState();
  const [nodesConfig, setNodesConfig] = useState();

  useEffect(() => {
    const configTasksList = tasks.filter((task) => task.status === 'active').map((task) => ({
      title: task.title,
      titleDescription: "Add task",
      icon: task.avatar?.split("#000000").join(task.avatarColor),
      type: "GenericNode",
      nodeType: `task:${task.id}`,
      bgColor: task.backgroundColor,
    }));

    const normalizeTasksNodes = nodeItemsConfig.map((node) => {
      if (node.title === "Tasks") {
        return { ...node, items: configTasksList };
      }

      return node;
    });

    // Enrollment uses a restricted palette but the SAME full node definitions as
    // scenarios — the editor needs the complete definitions map (message:*,
    // task:*, if-branch internals) to initialize, so we only swap the palette
    // and augment data nodes with the alias / saveToProfile fields below.
    if (itemType === 'enrollment') {
      setNodesConfig(itemsConfigOverride || enrollmentItemsConfig);
    } else {
      setNodesConfig(normalizeTasksNodes);
    }

    // All editor surfaces - including baseline surveys (surveyTask) - use the
    // local node definitions so local field additions like the Required toggle
    // (LF360-1791) render everywhere. Previously surveyTask was skipped here and
    // the survey editor fell back to the scenario-designer package's bundled
    // definitions, which omit local additions. Surveys have no task:* palette
    // entry, so the task:* enum/options population below is inert for them.
    const nodeDefinitionsDeepCopy = JSON.parse(JSON.stringify(nodeDefinitions));

    let nodeDefinitionsTasks = nodeDefinitionsDeepCopy["task:*"];

    nodeDefinitionsTasks.validationSchema.properties.nodeType.enum =
      configTasksList.map((task) => task.nodeType);

    nodeDefinitionsTasks.nodeInfoContent[0].options = configTasksList.map(
      (task) => ({ label: task.title, value: task.nodeType })
    );

    nodeDefinitionsDeepCopy["task:*"] = nodeDefinitionsTasks;

    if (itemType === 'enrollment') {
      augmentEnrollmentDefinitions(nodeDefinitionsDeepCopy);
    }

    setNormalizeNodeDefinitions(nodeDefinitionsDeepCopy);
  }, [tasks, nodeItemsConfig, nodeDefinitions, itemType, itemsConfigOverride]);

  return { nodesConfig, nodesDefinitions: normalizeNodesDefinitions };
};

export default useScenarioConfig;
